// extracted by mini-css-extract-plugin
export default {"title":"UserAccount_title__E30s9","gap_20":"UserAccount_gap_20__jn+v6","user_data_item_width":"UserAccount_user_data_item_width__s0p9N","padding_50":"UserAccount_padding_50__kl5Ko"};